import { useState, useEffect } from 'react';
import { getStaff } from './api';

/* People helpers: every role a staff member has, and their nickname shown next to their name.
   Nicknames are unique, so "Ryan Lopez · R-Money" tells two Ryans apart everywhere.         */

export const ROLE_LIST = ['Sales Rep', 'Telemarketer', 'Canvasser', 'Confirmer', 'Production'];

export function rolesOf(s) {
  let list = [];
  try { list = Array.isArray(s?.roles) ? s.roles : JSON.parse(s?.roles || '[]'); } catch (e) { list = []; }
  if (!Array.isArray(list)) list = [];
  if (s?.role && !list.includes(s.role)) list = [s.role, ...list];
  return list;
}
export const hasRole = (s, role) => rolesOf(s).includes(role);
export const withNick = (name, nick) => (name && nick ? `${name} · ${nick}` : name || '');

// name (lower-case) → nickname, loaded once per page load and shared
let cache = null, waiting = null;
export function useNicknames() {
  const [map, setMap] = useState(cache || {});
  useEffect(() => {
    if (cache) return;
    waiting = waiting || getStaff().then(list => {
      const m = {};
      (list || []).forEach(s => { if (s.nickname) m[String(s.name || '').trim().toLowerCase()] = s.nickname; });
      cache = m; return m;
    }).catch(() => ({}));
    let live = true;
    waiting.then(m => { if (live) setMap(m); });
    return () => { live = false; };
  }, []);
  return name => withNick(name, map[String(name || '').trim().toLowerCase()]);
}
export const clearNicknameCache = () => { cache = null; waiting = null; };

// Shrink a picked photo to a 512px JPEG before uploading (keeps uploads small and fast)
export function resizePhoto(file, size = 512) {
  return new Promise((resolve, reject) => {
    if (!file || !/^image\//.test(file.type)) return reject(new Error('Pick an image file (JPG or PNG)'));
    const img = new Image();
    const url = URL.createObjectURL(file);
    img.onload = () => {
      const s = Math.min(img.width, img.height);            // square crop from the centre
      const c = document.createElement('canvas'); c.width = size; c.height = size;
      c.getContext('2d').drawImage(img, (img.width - s) / 2, (img.height - s) / 2, s, s, 0, 0, size, size);
      URL.revokeObjectURL(url);
      resolve(c.toDataURL('image/jpeg', 0.85));
    };
    img.onerror = () => { URL.revokeObjectURL(url); reject(new Error('Could not read that image')); };
    img.src = url;
  });
}
